import React from "react";
import { Steering, Key } from "./icons/Icons";
import { TID } from "../lib/testIds";

/**
 * Dual mode toggle: chauffeur | rental.
 * Uses gold background sliding indicator with black text.
 */
export default function ModeToggle({ mode, onChange, size = "lg" }) {
  const pillPad = size === "lg" ? "px-6 py-3 text-sm" : "px-4 py-2 text-xs";
  return (
    <div
      data-testid={TID.home.modeToggle}
      className="glass inline-flex p-1 rounded-full relative"
    >
      <button
        data-testid={TID.home.chauffeurBtn}
        onClick={() => onChange("chauffeur")}
        className={`relative z-10 flex items-center gap-2 rounded-full ${pillPad} font-medium transition-colors ${
          mode === "chauffeur" ? "text-ink-900" : "text-white/70 hover:text-white"
        }`}
      >
        <Steering size={18} />
        <span>Book a Ride</span>
      </button>
      <button
        data-testid={TID.home.rentalBtn}
        onClick={() => onChange("rental")}
        className={`relative z-10 flex items-center gap-2 rounded-full ${pillPad} font-medium transition-colors ${
          mode === "rental" ? "text-ink-900" : "text-white/70 hover:text-white"
        }`}
      >
        <Key size={18} />
        <span>Rent a Vehicle</span>
      </button>
      <div
        aria-hidden="true"
        className="absolute top-1 bottom-1 rounded-full btn-gold transition-all duration-500 ease-out"
        style={{
          width: "calc(50% - 4px)",
          left: mode === "chauffeur" ? "4px" : "calc(50%)",
        }}
      />
    </div>
  );
}
